export const TIMER_OFFSET_SEC = 300
export const ONE_SECOND_MS = 1000
export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS

export const CSS_CLASSES = {
  hidden: 'ext-hidden',
  grid: 'ext-grid',
  sending: '...wird gesendet'
}
export const BUTTON_CLASSES = {
  finish: '.finish-link',
  billAddressToggle: '#rechnungsadresse',
  passwordToggle: '.login-eye'
}
export const ELEMENT_SELECTORS = {
  billAddress: '.bill-address',
  timer: '[data-time]',
  registrationForm: 'form[name="registration"]',
  passwordInput: '#password'
}